import { useTranslation } from 'react-i18next';
import { gql } from '@apollo/client';
import {
  MetricSummaryAnsweredConversationsWhereInput,
  Query,
} from '@lgg/isomorphic/types/__generated__/graphql';
import {
  CardMainNumericValue,
  GenericSmallCard,
} from 'src/components/pages/dashboard/components/shared';

export const GET_METRIC_SUMMARY_ANSWERED_CONVERSATIONS_QUERY = gql`
  query GetMetricSummaryAnsweredConversations(
    $institutionId: Int!
    $period: MetricPeriodWhereInput!
    $comparePeriod: MetricComparePeriodInput
    $where: MetricSummaryAnsweredConversationsWhereInput
  ) {
    metricSummaryAnsweredConversations(
      institutionId: $institutionId
      period: $period
      comparePeriod: $comparePeriod
      where: $where
    ) {
      total
      previousPeriod {
        total
        trendChangePercentage
        trendChangeIndicator
      }
      lastUpdatedAt
    }
  }
`;

export const SummaryAnsweredConversationsCard = () => {
  const { t } = useTranslation(['dashboard']);

  return (
    <GenericSmallCard<
      Pick<Query, 'metricSummaryAnsweredConversations'>,
      MetricSummaryAnsweredConversationsWhereInput
    >
      title={t('dashboard:cards.summaryAnsweredConversations.title')}
      query={GET_METRIC_SUMMARY_ANSWERED_CONVERSATIONS_QUERY}
      dataResolver={(result) => {
        const metricData = result.data?.metricSummaryAnsweredConversations;

        if (!metricData) {
          return undefined;
        }

        const { lastUpdatedAt, total = null, previousPeriod = null } = metricData;

        return {
          lastUpdatedAt,
          total,
          previousPeriod: previousPeriod
            ? {
                trendChangePercentage: previousPeriod?.trendChangePercentage ?? 0,
                trendChangeIndicator: previousPeriod.trendChangeIndicator,
                total: previousPeriod?.total ?? 0,
              }
            : null,
        };
      }}
      whereResolver={({ targetUserId }) => ({
        dimensionContactAssignee: { id: { _eq: targetUserId } },
      })}
      valueTransformer={(value = null) => <CardMainNumericValue value={value} />}
      cardInfoI18nKey="dashboard:cards.summaryAnsweredConversations.tooltipDescription"
      testId="dashboard-summary-answered-conversations-card"
    />
  );
};
